import type { HttpClient } from '@wix/http-client'

const url = '/_api/premium-store/plans/premiumStatus'

export const getPremiumState = async ({
  httpClient,
  metaSiteId,
}: {
  httpClient: HttpClient
  metaSiteId: string
}): Promise<'FREE' | 'PREMIUM_MAX_PLAN' | 'PREMIUM'> => {
  const { data: premiumStatus } = await httpClient.get(url, {
    params: { metaSiteId },
  })
  return premiumStatus.premiumState || premiumStatus.payload.premiumState
}
